import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Astound,
  BuckeyeBroadband,
  Comcast,
  Cox,
  Mediacom,
  Optimum,
  Spectrum,
  TDS,
  WOW,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

// Changelog - https://updater.atlassian.net/browse/COREX-1229
export const XfinityBravePartner: SingleProviderConfig = {
  name: 'XfinityBravePartner',
  micrositeCode: 'XfinityBrave',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com/deals1',
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '888-229-3396',
  fallbackLeadModePhoneNumber: '855-555-0017',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: true,
  source: 'Xfinity',
  noOffersRetry: 2,
  commercialHomepage: 'https://comcastbusinessspecial.com',
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: false,
  getCheckoutType: asyncEligible,
};
